import { render, staticRenderFns } from "./PlantRow.vue?vue&type=template&id=6c7f1faa&scoped=true&"
import script from "./PlantRow.vue?vue&type=script&lang=js&"
export * from "./PlantRow.vue?vue&type=script&lang=js&"
import style0 from "./PlantRow.vue?vue&type=style&index=0&id=6c7f1faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f1faa",
  null
  
)

export default component.exports